// Apoio ao painel colapsável de descrições no detalhe do produto
const STORAGE_KEY = 'muven.product.descriptionOpen'
const PREVIEW_MAX = 160

// Texto puro e de uma linha, para a prévia mostrada com o painel fechado
export function descriptionPreview(html: string, max: number = PREVIEW_MAX): string {
    if (!html) {
        return ''
    }

    const spaced = html.replace(/<br\s*\/?>|<\/(p|div|li|h[1-6])>/gi, ' ')
    let text = spaced.replace(/<[^>]*>/g, '')

    if (typeof DOMParser !== 'undefined') {
        // Decodifica entidades (&amp;, &nbsp; ...) sem executar nada
        text = new DOMParser().parseFromString(text, 'text/html').documentElement.textContent || ''
    }

    text = text.replace(/\s+/g, ' ').trim()

    if (text.length <= max) {
        return text
    }

    return `${text.slice(0, max).replace(/\s+\S*$/, '')}...`
}

// Começa fechado; lembra a última escolha de quem está usando
export function readDescriptionOpen(): boolean {
    try {
        return window.localStorage.getItem(STORAGE_KEY) === '1'
    } catch (e) {
        return false
    }
}

export function saveDescriptionOpen(open: boolean): void {
    try {
        window.localStorage.setItem(STORAGE_KEY, open ? '1' : '0')
    } catch (e) {
        // Sem armazenamento (aba privada, bloqueio): segue só na sessão
    }
}
